import { Alert, Flex, Form, Input, Modal } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const ScheduleCreateModalContainer = styled(Modal)<{ $isScheduleCreateFullSizeOpen: boolean }>`
  ${({ theme: { kcc }, $isScheduleCreateFullSizeOpen }): FlattenSimpleInterpolation => css`
    width: ${$isScheduleCreateFullSizeOpen ? 800 : 530}px;

    .ant-modal-content {
      padding-inline: 0;
    }

    .ant-modal-header {
      margin: 0;
      padding-bottom: ${kcc.size.S150}px;
      padding-inline: ${kcc.size.S250}px;
      font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
      line-height: 24px;

      .ant-btn {
        width: ${kcc.size.S300}px;
        height: ${kcc.size.S300}px;
        padding: 0;
      }

      svg {
        width: ${kcc.size.S300}px;
        height: ${kcc.size.S300}px;
      }

      .schedule-name-edit-icon svg {
        width: ${kcc.size.S250}px;
        height: ${kcc.size.S250}px;
      }
    }

    .ant-modal-body {
      height: ${$isScheduleCreateFullSizeOpen ? '644px' : '100%'};
      max-height: ${$isScheduleCreateFullSizeOpen ? '100%' : '548px'};
      padding-block: ${kcc.size.S50}px; // to avoid losing outline
      overflow-y: auto;
    }

    .ant-modal-footer {
      margin: 0;
      padding-inline: ${kcc.size.S250}px;
      padding-top: ${kcc.size.S200}px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  `}
`;

export const IconContainer = styled.div`
  width: ${({ theme: { kcc } }): number => kcc.size.S300}px;
  height: ${({ theme: { kcc } }): number => kcc.size.S300}px;
`;

export const ScheduleNameInput = styled(Input)`
  padding: 0;
  border: none;
  border-radius: 0;
  color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.HEADING_5}px;
  font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  background-color: transparent;

  &:disabled {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  }

  &::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }

  &.kcc-theme-input {
    &:focus,
    &:focus-within,
    &:hover,
    &:active {
      outline: none !important;
    }
  }
`;

export const ScheduleNameInputEditable = styled(Input)`
  height: 40px;
  color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.LG}px;
  font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  line-height: 1.2;

  &:disabled {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  }

  &::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }
`;

export const ScheduleNameText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme: { kcc } }): string => kcc.colors.TEXT};
  font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.HEADING_5}px;
  font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
`;

export const ScheduleAlert = styled(Alert)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    border: none;
    padding: ${kcc.padding.CONTENT_VERTICAL}px ${kcc.padding.CONTROL_HORIZONTAL}px;
    color: ${kcc.colors.TEXT};
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    background-color: ${kcc.colors.ORANGE[50]};
    margin-bottom: ${kcc.spacing.SM};
  `}
`;

export const ScheduleContainer = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    gap: ${kcc.spacing.BASE};
    padding-inline: ${kcc.padding.CONTROL_HORIZONTAL}px;
  `}
`;

export const ScheduleCreateModalFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;

  .ant-form-item-control-input {
    min-height: 0;
  }

  &.schedule-name-field-visible {
    flex: 1;
    min-width: 0;
  }

  .ant-form-item-explain-error {
    margin-top: 4px;
    color: ${({ theme: { kcc } }): string => kcc.colors.ERROR};
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.REGULAR};
  }

  input::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }

  &.schedule-name-edit-field {
    position: relative;

    .ant-form-item-explain-error {
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  /* Higher specificity than .schedule-name-edit-field's position: relative above. */
  &.schedule-name-edit-field.schedule-name-field-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
  }
`;
